import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'

import { CustomConfirmDialog } from '../../../../../../components/dialogs'
import { useToastContext } from '../../../../../../contexts/toast'
import { requestAttachmentDelete } from '../../../../data/api'

type Props = {
  attachmentId: string
  attachmentUrl: string
  attachmentName: string
  despatchAdviceId: string
}

export const Delete: React.FC<Props> = ({
  attachmentId,
  attachmentUrl,
  attachmentName,
  despatchAdviceId,
}) => {
  const { t } = useTranslation()
  const { showToast } = useToastContext()
  const [isRequestRunning, setIsRequestRunning] = useState<boolean>(false)
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const handleShow = () => setIsVisible(true)
  const handleHide = () => setIsVisible(false)

  const handleDelete = async () => {
    setIsRequestRunning(true)

    try {
      await requestAttachmentDelete(
        despatchAdviceId,
        attachmentId,
        attachmentUrl,
      )

      showToast({
        severity: 'success',
        summary: t(
          'despatchAdvice.attachments.table.delete.dialog.delete.messages.success.summary',
        ),
        detail: t(
          'despatchAdvice.attachments.table.delete.dialog.delete.messages.success.detail',
          { name: attachmentName },
        ),
        life: 3000,
      })
    } catch (error) {
      showToast({
        severity: 'error',
        summary: t(
          'despatchAdvice.attachments.table.delete.dialog.delete.messages.failure.summary',
        ),
        detail: t(
          'despatchAdvice.attachments.table.delete.dialog.delete.messages.failure.detail',
          { name: attachmentName },
        ),
        sticky: true,
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  return (
    <>
      <Button
        icon={'pi pi-trash'}
        className="p-button-rounded p-button-text"
        severity="danger"
        onClick={handleShow}
        loading={isRequestRunning}
      />

      <CustomConfirmDialog
        severity="danger"
        isVisible={isVisible}
        header={t('despatchAdvice.attachments.table.delete.dialog.title')}
        message={t(
          'despatchAdvice.attachments.table.delete.dialog.description',
        )}
        onHide={handleHide}
        onReject={handleHide}
        onAccept={handleDelete}
        acceptLabel={t('common.buttons.delete')}
        rejectLabel={t('common.buttons.cancel')}
      />
    </>
  )
}
